import React from 'react';

interface Level1EmptyProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

export const Level1Empty = ({width = 500, height = 500, className}: Level1EmptyProps) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 500 500'
    fill='inherit'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
    role='img'
    aria-label='Empty Level 1 Badge'
  >
    <g filter='url(#filter0_i_4102_1374)'>
      <path
        d='M385.309 434.5C396.283 434.5 406.861 430.399 414.968 423.002L438.654 401.388C453.898 387.477 457.426 364.84 447.138 346.95L297.963 87.5643C290.113 73.9144 275.567 65.5 259.821 65.5H240.179C224.433 65.5 209.887 73.9144 202.037 87.5643L52.8624 346.95C42.5738 364.84 46.1016 387.477 61.3461 401.388L85.0324 423.002C93.1388 430.399 103.717 434.5 114.691 434.5H385.309Z'
        fill='inherit'
      />
    </g>
    <defs>
      <filter
        id='filter0_i_4102_1374'
        x='47.0029'
        y='65.5'
        width='405.994'
        height='385'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='16' />
        <feGaussianBlur stdDeviation='32' />
        <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
        <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0' />
        <feBlend mode='normal' in2='shape' result='effect1_innerShadow_4102_1374' />
      </filter>
    </defs>
  </svg>
);
